import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useLicitacoesState } from "../context/licitacoes-context";
import { useLicitacoesController } from "../context/licitacoes-controller";
import { LicitacaoForm } from "./licitacao-form";

export const LicitacaoDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useLicitacoesController();
    const { dataResponse, showAddEdit } = useLicitacoesState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Licitação ${dataResponse?.id}`;
        return "Adicionar Licitação";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <LicitacaoForm />
        </DefaultDrawer>
    );
};
